const customerAddressDialogTemplate = [
    {
        title: 'General',
        fields: [
            {
                label: 'Name',
                component: 'VTextField',
                model: 'name',
                required: true,
                rules: 'required'
            },

            {
                label: 'Last Name',
                component: 'VTextField',
                model: 'lastname'
            },
            {
                label: 'Id Document',
                component: 'VTextField',
                model: 'docid'
            },
            {
                label: 'Phone No.',
                component: 'VTextField',
                model: 'phone'
            },
            {
                label: 'Email',
                component: 'VTextField',
                model: 'email',
                required: true,
                rules: 'required'
            },
            {
                label: 'Mobile Phone No.',
                component: 'VTextField',
                model: 'mobile'
            }
        ]
    },
    {
        title: 'Emails',
        fields: [
            {
                label: 'Emails',
                component: 'EmailTagField',
                initialValue: false,
                model: 'emailAddresses',
                oneColumn: true
            }
        ]
    },
    {
        title: 'Address',
        fields: [
            {
                label: 'Address',
                component: 'VTextField',
                model: 'address',
                required: true,
                rules: 'required'
            },
            {
                label: 'City',
                component: 'City',
                model: 'city',
                returnObject: true,
                required: true,
                rules: 'required'
            },
            {
                label: 'State',
                disabled: true,
                component: 'VTextField',
                model: 'state',
                required: true
            },
            {
                label: 'Zip Code',
                component: 'VTextField',
                model: 'zip'
            },
            {
                label: 'Country',
                disabled: true,
                component: 'VTextField',
                model: 'country'
            }
        ]
    }
];

export default customerAddressDialogTemplate;
